import type { JSX } from "react";
import { EffectComposer, Bloom, Vignette } from "@react-three/postprocessing";
import { useSceneStore } from "@/state/useSceneStore";

export const Postprocessing = (): JSX.Element | null => {
  const quality = useSceneStore((s) => s.quality);
  if (quality === "low") return null;
  return (
    <EffectComposer>
      <Bloom
        intensity={quality === "high" ? 0.5 : 0.3}
        luminanceThreshold={0.7}
        mipmapBlur
      />
      <Vignette eskil={false} offset={0.3} darkness={0.4} />
    </EffectComposer>
  );
};
